import {responsiveFontSizes, createMuiTheme} from "@material-ui/core";

const theme = responsiveFontSizes(createMuiTheme({
    palette: {
        type: "dark"
    }
}));

export default theme;
